@if (info?.isVisible) {
  <div [id]="cardId" class="mt-7">
    <mwe-basic-card>
      <h4><i [ngClass]="info.iconClass"></i><br />{{ info.title }}</h4>
      <p [innerHTML]="info.text"></p>
      <mwe-button class="d-block mb-3" color="blue" [buttonId]="buttonId" [labelKey]="info.btn" (clicked)="startProcess()" />
    </mwe-basic-card>
  </div>
}
